export const wishlistLandingPageAnalytics = (deviceType, numberOfLists, fireTag) => {
  if (!import.meta.client) return;
  // Defer heavy tag calculations to idle time to improve INP
  const runIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
  runIdle(() => {
    const brand = import.meta.env.VITE_ENTRY_POINT;

    const firetagControl = brand === 'mcom' && numberOfLists === 0;
    const utagDataMcom = {
      page_name: 'wishlist home',
      page_type: 'wishlist',
      wishlist_nbr_of_lists: numberOfLists,
      device: deviceType,
    };
    const utagDataBcom = {
      page_name: 'wishlist home',
      page_type: 'wishlist',
      site_type: deviceType === 'PC' ? 'desktop' : 'mobile',
    };

    if (!firetagControl) {
      fireTag('view', brand === 'mcom' ? utagDataMcom : utagDataBcom);
    }
  });
};

export const wishlistCreatePageAnalytics = (actionName, actionMisc, fireTag) => {
  if (!import.meta.client) return;
  const runIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
  runIdle(() => {
    const utagData = {
      event_name: 'wishlist create',
      site_action_name: actionName,
      action_location: 'wishlist',
      action_misc: actionMisc,
    };
    fireTag('link', utagData);
  });
};

export const setupBreadcrumbAnalytics = (fireTag) => {
  if (!import.meta.client) return;
  const breadcrumbList = document.querySelectorAll('.p-menuitem');
  let utagDataValue = '';
  const handleBreadcrumbClick = (breadcrumb) => {
    const anchor = breadcrumb.querySelector('a');
    // skip if breadcrumb is not clickable
    if (!anchor || ['page', 'location'].includes(anchor.getAttribute('aria-current'))) return;
    const breadcrumbText = breadcrumb.innerText?.trim().toLowerCase();
    if (anchor.href.includes('home') || anchor.title?.includes("Macy's homepage")) {
      utagDataValue = breadcrumbText === '' ? 'homepage' : breadcrumbText;
    } else if (anchor.href.includes('myaccount')) {
      utagDataValue = breadcrumbText;
    }
    if (utagDataValue) {
      const utagData = {
        event_name: `wishlist breadcrumb:${utagDataValue}`,
        link_name: `wishlist breadcrumb:${utagDataValue}`,
      };
      const url = anchor.getAttribute('href');
      anchor.preventDefault?.();
      // Fire tags in idle to allow routing to begin as quickly as possible
      const runIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
      runIdle(() => fireTag('link', utagData, { immediate: true }));
      setTimeout(() => (url.startsWith('/wishlist') ? navigateTo(url) : navigateTo(url, { external: true })), 50);
    }
  };
  breadcrumbList.forEach((breadcrumb) => {
    breadcrumb.addEventListener('click', (event) => {
      event.preventDefault();
      handleBreadcrumbClick(breadcrumb);
    });
  });
  // Cleanup function to remove event listeners
  return () => {
    breadcrumbList.forEach((breadcrumb) => {
      breadcrumb.removeEventListener('click', handleBreadcrumbClick);
    });
  };
};

export const wishlistErrorAnalytics = (errorObj, fireTag) => {
  if (!import.meta.client) return;
  const runIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
  runIdle(() => {
    const ensureArray = (value) => {
      if (Array.isArray(value)) {
        return value;
      }
      if (value != null) {
        return [String(value)];
      }
      return undefined;
    };

    // Handle both formats: direct properties and nested .value properties
    const errorData = errorObj?.value || errorObj;
    const utagData = {
      event_name: 'wishlist error',
      link_name: 'wishlist error',
      error_category: errorData?.errorCategory || errorData?.error_category || 'wishlist',
      error_code: ensureArray(errorData?.errorCodes || errorData?.error_code || errorData?.codes || errorData?.errorCode),
      error_label: ensureArray(errorData?.errorLabels || errorData?.error_label || errorData?.labels || errorData?.developerMessage),
      error_message: ensureArray(errorData?.errorMessages || errorData?.error_message || errorData?.messages || errorData?.message),
      error_scope: ['global'],
      error_misc: [''],
    };

    fireTag('link', utagData);
  });
};

export default {
  wishlistLandingPageAnalytics,
  wishlistCreatePageAnalytics,
  setupBreadcrumbAnalytics,
  wishlistErrorAnalytics,
};
